<template>
  <div :class="$className.radio.container">
    <div
      v-for="(item, idx) in selectableInputs"
      :key="idx"
      :class="$className.radio.root"
    >
      <input
        v-model="value"
        :name="name"
        :id="`${name}.${item.value}`"
        :value="item.value"
        type="radio"
        :class="[$className.radio.input, item.value === value ? 'checked' : '']"
      />
      <label
        :for="`${name}.${item.value}`"
        :class="$className.radio.label"
        v-html="item.label"
        :id="labelId"
      ></label>
    </div>
  </div>
</template>

<script setup>
import { watch, computed } from 'vue';
import { useStore } from 'vuex';
import { useField } from 'vee-validate';

const store = useStore();
const props = defineProps({
  name: {
    type: String,
    required: true
  },
  validator: {
    type: Object,
    required: true
  },
  selectableItems: {
    type: Array,
    required: true
  },
  labelId: {
    type: String,
    default: ''
  },
  labelTemplate: {
    type: String,
    required: false,
    default: '{}'
  },
  dispatcher: {
    type: String,
    required: true
  }
});

const initialValue = computed(() => store.state.formData[props.name]);

const { value } = useField(props.name, props.validator, {
  validateOnMount: false,
  initialValue: initialValue.value
});

watch(value, newValue => store.dispatch(props.dispatcher, newValue));

const selectableInputs = computed(() => {
  return props.selectableItems.map(item => ({
    value: item.value,
    label: props.labelTemplate.replace('{}', item.label)
  }));
});
</script>
